/**
 * Stable error codes. The API never returns a stack trace or a raw driver
 * message — it returns one of these plus a safe human message, and the
 * frontend switches on the code.
 */
export const ERROR_CODES = {
    // auth
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    ACCOUNT_SUSPENDED: "ACCOUNT_SUSPENDED",
    ACCOUNT_PENDING: "ACCOUNT_PENDING",
    KYC_NOT_APPROVED: "KYC_NOT_APPROVED",
    PASSWORD_CHANGE_REQUIRED: "PASSWORD_CHANGE_REQUIRED",
    TEMP_PASSWORD_EXPIRED: "TEMP_PASSWORD_EXPIRED",
    UNAUTHENTICATED: "UNAUTHENTICATED",
    FORBIDDEN: "FORBIDDEN",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    TOKEN_REUSED: "TOKEN_REUSED",
    // otp
    OTP_INVALID: "OTP_INVALID",
    OTP_EXPIRED: "OTP_EXPIRED",
    OTP_ATTEMPTS_EXCEEDED: "OTP_ATTEMPTS_EXCEEDED",
    OTP_COOLDOWN: "OTP_COOLDOWN",
    OTP_CHANNEL_UNAVAILABLE: "OTP_CHANNEL_UNAVAILABLE",
    // tenancy
    ORG_NOT_FOUND: "ORG_NOT_FOUND",
    ORG_SUSPENDED: "ORG_SUSPENDED",
    TENANT_CONTEXT_MISSING: "TENANT_CONTEXT_MISSING",
    SLUG_TAKEN: "SLUG_TAKEN",
    SLUG_RESERVED: "SLUG_RESERVED",
    // branding
    CONTRAST_TOO_LOW: "CONTRAST_TOO_LOW",
    INVALID_TOKEN_VALUE: "INVALID_TOKEN_VALUE",
    // rewards
    CODE_ALREADY_USED: "CODE_ALREADY_USED",
    CODE_USED_BY_YOU: "CODE_USED_BY_YOU",
    CODE_VOID: "CODE_VOID",
    /** D-20: a tracked code that has not been dispatched down to a shop yet. */
    CODE_NOT_AT_SHOP: "CODE_NOT_AT_SHOP",
    INSUFFICIENT_POINTS: "INSUFFICIENT_POINTS",
    KYC_PENDING_FOR_REDEEM: "KYC_PENDING_FOR_REDEEM",
    // generic
    VALIDATION_FAILED: "VALIDATION_FAILED",
    NOT_FOUND: "NOT_FOUND",
    CONFLICT: "CONFLICT",
    RATE_LIMITED: "RATE_LIMITED",
    PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE",
    INTERNAL: "INTERNAL",
};
//# sourceMappingURL=errors.js.map